import { render, staticRenderFns } from "./WarnList.vue?vue&type=template&id=11a640dd&scoped=true&"
import script from "./WarnList.vue?vue&type=script&lang=ts&"
export * from "./WarnList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a640dd",
  null
  
)

export default component.exports